<div fxLayout *ngIf="perms$.permissions | async as perms">
  <main [ngClass.lt-md]="{ mobile: true }">
    <header>
      <div class="container">
        <app-feature-flag-tabs>
          <ng-container navTabs>
            <sbnb-page-header [parentPath]="'menu-mobile'">
              <h2 class="!m-0 block sbnbDesktop:hidden">Help center</h2>
            </sbnb-page-header>
            <h2 class="hidden sbnbDesktop:block">Hello {{ user?.first_name || 'there' }}, how can we help you?</h2>
            <h3 class="block sbnbDesktop:hidden">Hello {{ user?.first_name || 'there' }}, how can we help you?</h3>
            <a [routerLink]="['/support-documentation/search']" class="header-search">
              <sbnb-search-field></sbnb-search-field>
            </a>
          </ng-container>
          <h2>Hello {{ user?.first_name || 'there' }}, how can we help you?</h2>
          <a [routerLink]="['/support-documentation/search']" class="header-search">
            <sbnb-search-field></sbnb-search-field>
          </a>
        </app-feature-flag-tabs>
      </div>
    </header>
    <div *ngIf="loading" style="display: flex; justify-content: center; align-items: center">
      <img src="/assets/images/preloader.gif" alt="Loading..." />
    </div>
    <div class="container" *ngIf="!loading">
      <section class="mb-24">
        <sbnb-onboarding-helper></sbnb-onboarding-helper>
      </section>

      <section class="mb-80 callout-grid">
        <sbnb-callout-card
          *ngIf="showBookAnOnboardingCallAction"
          title="Book an Orientation"
          icon="headphones"
          (click)="onboardingCall()">
          Book a free call with our team to help you get started!
        </sbnb-callout-card>

        <sbnb-callout-card title="Contact support" icon="help" (click)="openIntercom()">
          Contact our support team via chat now.
        </sbnb-callout-card>

        <sbnb-callout-card
          [disabled]="!perms.is_admin && !perms.is_team_owner"
          title="Give Feedback"
          icon="headphones"
          route="/support-documentation/schedule-a-call">
          {{
            perms.is_admin || perms.is_team_owner
              ? 'Schedule a call with our product specialists.'
              : 'Contact your team manager to arrange a call with our product specialists.'
          }}
        </sbnb-callout-card>
        <sbnb-callout-card
          title="See product updates"
          icon="bell"
          url="https://changelog.hospitable.com/"
          target="_blank"
          (click)="clearHeadwayUnseenCount()">
          Discover what we have been working on lately.
          <div extra class="headway-unseen-count" *ngIf="headwayUnseenCount > 0">
            {{ headwayUnseenCount }}
          </div>
        </sbnb-callout-card>
        <sbnb-callout-card
          title="Getting started"
          icon="video-player-movie-1"
          route="/support-documentation/category/3137423-getting-started">
          Training videos and guides to get you started
        </sbnb-callout-card>
      </section>
      <section class="mb-80">
        <sbnb-support-documentation-title
          title="Browse by category"
          icon="question-mark"></sbnb-support-documentation-title>
        <sbnb-category-card-grid [categories]="categories"></sbnb-category-card-grid>
      </section>
      <section class="cols-2 mb-80">
        <sbnb-article-list icon="recent" title="Recent articles" [articles]="recent_articles"></sbnb-article-list>
        <sbnb-article-list icon="popular" title="Popular articles" [articles]="popular_articles"></sbnb-article-list>
      </section>

      <div class="privacy-policy-container">
        <a class="text__small raspberry-darker" [href]="config.PRIVACY_POLICY_URL" target="_blank">Privacy policy</a>
      </div>
    </div>
  </main>
  <div class="headway"></div>
</div>
